import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const pushSupported = () =>
  typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

function urlBase64ToUint8Array(value) {
  const padding = "=".repeat((4 - (value.length % 4)) % 4);
  const base64 = (value + padding).replace(/-/g, "+").replace(/_/g, "/");
  return Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
}

export async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    return await navigator.serviceWorker.register("/sw.js");
  } catch (e) {
    console.warn("[push] SW register failed", e?.message);
    return null;
  }
}

export async function getCurrentSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration("/sw.js") || await navigator.serviceWorker.ready;
  return reg?.pushManager?.getSubscription() || null;
}

/** Ask permission (must run from a user gesture) and register the device with the backend. */
export async function enablePush() {
  if (!pushSupported()) throw new Error("Este navegador não suporta notificações push");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Permissão de notificações negada");
  const reg = (await registerServiceWorker()) || (await navigator.serviceWorker.ready);
  await navigator.serviceWorker.ready;
  const { data } = await axios.get(`${API}/push/public-key`);
  if (!data?.publicKey) throw new Error("Push não configurado no servidor");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlBase64ToUint8Array(data.publicKey) });
  }
  const json = sub.toJSON();
  await axios.post(`${API}/push/subscribe`, { ...json, user_agent: navigator.userAgent });
  localStorage.setItem("pdv_push_enabled", "1");
  return sub;
}

export async function disablePush() {
  const sub = await getCurrentSubscription();
  if (sub) {
    try { await axios.delete(`${API}/push/subscribe`, { data: { endpoint: sub.endpoint } }); } catch { /* ignore */ }
    await sub.unsubscribe();
  }
  localStorage.removeItem("pdv_push_enabled");
}

/** Silently re-sync an existing granted subscription with the backend (e.g. after login on the same device). */
export async function syncPushIfGranted() {
  if (!pushSupported() || Notification.permission !== "granted") return false;
  try {
    const reg = (await registerServiceWorker()) || (await navigator.serviceWorker.ready);
    const sub = await reg.pushManager.getSubscription();
    if (!sub) return false;
    await axios.post(`${API}/push/subscribe`, { ...sub.toJSON(), user_agent: navigator.userAgent });
    localStorage.setItem("pdv_push_enabled", "1");
    return true;
  } catch { return false; }
}
